<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        <span v-if="form.contractType!=='服务订单'">外销名称</span>
        <span v-else>下单业务员名称</span>
        <span v-if="required" class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item prop="salesManCode">
          <el-select
            ref="createSale"
            v-model="salesMan"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width:100%;"
            value-key="userID"
            @change="change"
          >
            <el-option
              v-for="item in list"
              :key="item.userID"
              :label="item.userName"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getUserByName } from '@/API';
let timer;
export default {
  data () {
    return {
      list: [],
      loading: false,
      salesMan: {}
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        if (timer) {
          window.clearTimeout(timer);
        }
        timer = setTimeout(() => {
          this.loading = true;
          getUserByName(query).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.list = json.data;
            }
          }).catch(() => {
            this.loading = false;
          });
        }, 200);
      }
    },
    change (val) {
      this.$set(this.form, 'departmentName', val.deptName);
      // this.form.departmentName = val.deptName;
      this.form.salesManCode = val.userID;
      this.form.departmentCode = val.deptID;
      this.form.salesManName = val.userName;
    },
    initData () {
      if (this.form.salesManCode) {
        this.list = [{
          userID: this.form.salesManCode,
          userName: this.form.salesManName,
          deptName: this.form.departmentName,
          deptID: this.form.departmentCode
        }];
        this.salesMan = {
          userID: this.form.salesManCode,
          userName: this.form.salesManName,
          deptName: this.form.departmentName,
          deptID: this.form.departmentCode
        };
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="less"></style>
